import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Flex, Table, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoProduto } from "models/modelo_item_orcamento_produto";
import { useRef, useState } from "react";
import useNewProduct from "views/admin/config/newproduct/hooks/useNewProduct";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import AddItemRow from "./AddItemRow";
import ItemRow from "./ItemRow";


interface IItemProdutoTable {
    itemList: ModeloItemOrcamentoProduto[];
    categ: ModeloItemOrcamentoCategoria;
    borderColor: string;
    addRowItem: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
    deleteRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
    editRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
}

const ItemProdutoTable = ({itemList, borderColor, addRowItem, deleteRow, editRow, categ} : IItemProdutoTable) => {
    const [errorTitle, setErrorTitle] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [error, setError] = useState(false);
    const cancelRef = useRef(null);

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };
  const closeError = () => {
    setError(false);
  };
const {
    unidades
} = useMeasureUnit();
  
const {
    list
} = useNewProduct()

  return(
    <>
    <Table
      variant="striped"
      color="gray.500"
      mb="24px"
      mt="16px"
    >
      <Thead>
        <Tr>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #ITEM
            </Flex>
          </Th>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #CÓDIGO_SKU
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #UNIDADE
            </Flex>
          </Th>
          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #QTD
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #VALOR UN
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #TOTAL
            </Flex>
          </Th>

          <Th pe="10px" borderColor={borderColor} cursor="pointer">
            <Flex
              justifyContent="space-between"
              align="center"
              fontSize={{ sm: "10px", lg: "12px" }}
              color="gray.400"
            >
              #OPÇÕES
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
            <AddItemRow
                produtos={list}
                unidades={unidades}
                showError={showError}
                addRowItem={addRowItem}
                categ={categ}

            />
            {
                categ.ModeloOrcamentoItemProdutoList?.map((item) => 
                    <ItemRow
                    key={item.novoProdutoId}
                    item={item}
                    produtos={list}
                    showError={showError}
                    deleteRow={deleteRow}
                    editRow={editRow}
                    categ={categ}

                
                />)
            }
      </Tbody>
    </Table>
    <AlertDialog
      isOpen={error}
      leastDestructiveRef={cancelRef}
      onClose={closeError}
      isCentered
      motionPreset="slideInBottom"
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {errorTitle}
          </AlertDialogHeader>

          <AlertDialogBody>{errorMsg}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
              OK
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  </>
  )
}

export default ItemProdutoTable;


